module.exports = __webpack_public_path__ + "img/edylFAOk.36d47f6f.svg";